export default "__VITE_ASSET__BQTR5ZTQ__"